import { ApiHttpClient } from "../../common/http/api-http-client";
import { ResourceBaseService } from "../../common/resource-base/resource-base.service";
import { OptionType } from "@/types/OptionType";
import { IRequest } from "@/interfaces/IRequest";
import { ClientConditionCodeDto } from "./client-condition-code.dto";
import { CreateClientConditionCodeDto } from "./create-client-condition-code.dto";
import { UpdateClientConditionCodeDto } from "./update-client-condition-code.dto";
import { applyOptionLoaderPagination } from "@/core/common/presenters/optionLoader";

export class ClientConditionCodesResource extends ResourceBaseService<
  ClientConditionCodeDto,
  CreateClientConditionCodeDto,
  UpdateClientConditionCodeDto
> {
  protected EntityDto = ClientConditionCodeDto;
  protected CreateEntityDto = CreateClientConditionCodeDto;
  protected UpdateEntityDto = UpdateClientConditionCodeDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/client-condition-codes");
  }

  async optionLoader(inputValue: string): Promise<OptionType[]> {
    const request: IRequest = inputValue ? { search: inputValue, searchBy: ["id", "code"] } : {};
    request.sortBy = "code";
    const { data } = await this.findAll(applyOptionLoaderPagination(request));
    return data.map((value) => value.mapEntityToOptionType([`${value.code} (${value.days} días)`]));
  }
}
